<template>
  <div class="page-content">
    <h1>{{ $route.meta.title }}</h1>

    <UserSelector
      v-model="selectedUser"
      @input="handleUserChange"
      class="border-container"
    />

    <el-form
      ref="uesrForm"
      v-if="selectedUser"
      :model="selectedUser"
      class="border-container"
    >
      <el-form-item label="*區域類型">
        <el-select
          :value="String(selectedUser.areaType)"
          @input="$set(selectedUser, 'areaType', $event)"
          @change="saveUser({ areaType: $event })"
          placeholder="Select"
        >
          <el-option
            v-for="item in defaultOption.areaTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="*身份別">
        <el-select
          :value="String(selectedUser.class)"
          @input="$set(selectedUser, 'class', $event)"
          @change="saveUser({ class: $event })"
          placeholder="Select"
        >
          <el-option
            v-for="item in defaultOption.userClassOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-form ref="makeupOrderForm" :model="formData" class="border-container">
      <div class="order-info-section">
        <h2 class="title"><span>預約資訊</span></h2>

        <el-form-item label="*派單方式">
          <el-select
            :value="String(formData.deliveryMethod)"
            @change="formData.deliveryMethod = $event"
            placeholder="必填"
          >
            <el-option
              v-for="item in deliveryMethodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="*預定上車時間">
          <el-date-picker
            v-model="formData.estimateGetOnTime"
            type="datetime"
            placeholder="選擇上車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="*實際上車時間">
          <el-date-picker
            v-model="formData.getOnTime"
            type="datetime"
            placeholder="實際上車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="*實際下車時間">
          <el-date-picker
            v-model="formData.getOffTime"
            type="datetime"
            placeholder="實際下車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上車地址">
          <el-tabs :tab-position="'left'" style="height: 150px">
            <el-tab-pane label="地址輸入">
              <el-row :gutter="10">
                <el-col>
                  <el-autocomplete
                    v-model="formData.onLocation"
                    :fetch-suggestions="handleTypeIn"
                    placeholder="請輸入地址"
                    highlight-first-item
                    popper-class="wider-autocomplete"
                    @select="handleLocation('onLocation', $event)"
                  ></el-autocomplete>
                </el-col>
                <el-col>
                  <el-button
                    @click="
                      fillUserAddressGps((e) => handleLocation('onLocation', e))
                    "
                    :disabled="!selectedUser || !selectedUser.address"
                  >
                    同地址
                  </el-button>
                  <el-button
                    :disabled="!selectedHistoryAddress"
                    @click="() => fillHistoryAddressGps('onLocation')"
                  >
                    歷史上車點
                  </el-button>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="自訂地標">
              <el-autocomplete
                v-model="onlandmark"
                :fetch-suggestions="landmarkSearchAsync"
                placeholder="請輸入地址"
                highlight-first-item
                popper-class="wider-autocomplete"
                @select="handleLandmarkLocation('onLocation', $event)"
              ></el-autocomplete>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>

        <el-form-item label="上車經度">
          <el-input v-model="formData.onLocationGps[0]"></el-input>
          <label>上車緯度</label>
          <el-input v-model="formData.onLocationGps[1]"></el-input>
        </el-form-item>

        <el-form-item label="下車地址">
          <el-tabs :tab-position="'left'" style="height: 150px">
            <el-tab-pane label="地址輸入">
              <el-row :gutter="10">
                <el-col>
                  <el-autocomplete
                    class="auto"
                    v-model="formData.offLocation"
                    :fetch-suggestions="handleTypeIn"
                    placeholder="請輸入地址"
                    highlight-first-item
                    popper-class="wider-autocomplete"
                    @select="handleLocation('offLocation', $event)"
                  ></el-autocomplete>
                </el-col>
                <el-col>
                  <el-button
                    @click="
                      fillUserAddressGps((e) =>
                        handleLocation('offLocation', e),
                      )
                    "
                    :disabled="!selectedUser || !selectedUser.address"
                  >
                    同地址
                  </el-button>
                  <el-button
                    :disabled="!selectedHistoryAddress"
                    @click="() => fillHistoryAddressGps('offLocation')"
                  >
                    歷史下車點
                  </el-button>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="自訂地標">
              <el-autocomplete
                v-model="offlandmark"
                :fetch-suggestions="landmarkSearchAsync"
                placeholder="請輸入地址"
                highlight-first-item
                popper-class="my-kqoption"
                @select="handleLandmarkLocation('offLocation', $event)"
              ></el-autocomplete>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>

        <el-form-item label="下車經度">
          <el-input v-model="formData.offLocationGps[0]"></el-input>
          <label>下車緯度</label>
          <el-input v-model="formData.offLocationGps[1]"></el-input>
        </el-form-item>

        <div v-if="historyAddressData.length > 0" class="history-address">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>地址</th>
                  <th>經度</th>
                  <th>緯度</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(geo, index) in historyAddressData"
                  :key="`geo-${index}`"
                  @click="selectedHistoryAddress = geo"
                  :class="{
                    'history-address--selected': geo === selectedHistoryAddress,
                  }"
                >
                  <td>{{ geo.address }}</td>
                  <td v-if="geo.gps">{{ geo.gps[0] || '--' }}</td>
                  <td v-if="geo.gps">{{ geo.gps[1] || '--' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <el-form-item label="乘客數">
          <el-input
            type="number"
            placeholder="請輸入"
            v-model="formData.seat"
          ></el-input>
        </el-form-item>

        <el-form-item label="偏好服務" v-if="formData.service">
          <el-checkbox-group v-model="formData.service">
            <el-checkbox
              v-for="service in teamAvailableService"
              :label="service.teamServiceId"
              :key="`service-${service.teamServiceId}`"
            >
              {{ service.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="客服備註">
          <el-input
            type="textarea"
            autosize
            placeholder="請輸入"
            v-model="formData.serviceNote"
          ></el-input>
        </el-form-item>

        <el-form-item label="司機">
          <template>
            <DriverSelector
              :driver="formData.driver"
              :preferParams="{ service: formData.service }"
              @driver-updated="setDriverFields($event)"
            />
          </template>
        </el-form-item>

        <el-form-item label="使用車牌">
          <DriverLicenseSelector
            :driver="formData.licenseNumber"
            placeholder="注意：英文大寫，所有字母為半形字"
            :preferParams="{
              service: formData.service,
              searchFields: 'license_number',
            }"
            @driver-license-updated="setDriverLicenseFields($event)"
          />
        </el-form-item>

        <div class="order-info-section">
          <h2 class="title"><span>費用資訊</span></h2>
          <el-form-item label="補助方式">
            <template>
              <el-select
                v-model="formData.subsidyMethod"
                placeholder="請選擇"
                @change="changSubsidy"
              >
                <el-option
                  v-for="item in subsidyMethodOptions"
                  :key="item.value.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>

          <el-form-item label="里程數">
            <el-input
              type="number"
              placeholder="請輸入"
              v-model="formData.milage"
            ></el-input>
          </el-form-item>

          <el-form-item label="跳錶金額">
            <el-input placeholder="請輸入" v-model="formData.metreFare">
              >
            </el-input>
            <el-button @click="calculateSubsidyFare()">自動計算</el-button>
          </el-form-item>

          <el-form-item label="補助金額">
            <el-input
              placeholder="請輸入"
              disabled
              v-model="formData.subsidyFare"
            ></el-input>
          </el-form-item>

          <el-form-item label="實收金額">
            <el-input
              placeholder="請輸入"
              disabled
              v-model="formData.actualFare"
            ></el-input>
          </el-form-item>
        </div>

        <div class="text-right">
          <el-button type="primary" @click="makeupOrder()">確認</el-button>
          <el-button @click="resetFrom()">取消</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
const log = console.log
import _ from 'lodash'
import is from 'is_js'
import { defaultOption } from './defaultOption'
import longTermCareService from '@/API/longTermCareService'
// import coordinatePositioning from "@/mixins/PhoneHail/coordinatePositioning";
import coordinatePositioning from './_CoordinatePositioning'
import driverMixin from './_DriverMixin'
import UserSelector from './UserSelector'
import GoogleMapsLoader from 'google-maps'
import { ApiKey } from '../../assets/js/libs/GoogleAPI'

const defaultFormData = {
  deliveryMethod: 0,
}

export default {
  mixins: [coordinatePositioning, driverMixin],
  components: { UserSelector },
  data() {
    return {
      defaultOption,
      historyAddressData: [],
      selectedHistoryAddress: null,
      selectedUser: null,
      teamAvailableService: [],
      key: { onLocation: null, offLocation: null },
      formData: {
        ...defaultFormData,
        seat: 2,
        service: [],
        driver: null,
        driverId: null,
        licenseNumber: null,
        onLocationGps: [],
        offLocationGps: [],
      },
      cb: null,
      googleArray: [],
      geocoder: null,
      service: null,
      field: null,
      address: '',
      offlandmark: '',
      onlandmark: '',
      pickerOpt: {
        // disabledDate: (time) => {
        //   const SecondsOfDay = 60 * 60 * 24 * 1000;
        //   return time.getTime() + SecondsOfDay < new Date().getTime();
        // },
      },
    }
  },
  mounted() {
    this.fetchTeamService()
    GoogleMapsLoader.KEY = ApiKey()
    GoogleMapsLoader.LIBRARIES = ['places', 'geocoder']
    GoogleMapsLoader.load((google) => {
      this.service = new google.maps.places.AutocompleteService()
      this.geocoder = new google.maps.Geocoder()
    })
  },
  computed: {
    deliveryMethodOptions() {
      const excludeOptions = (opt) => {
        const { deliveryMethod, subsidyMethod } = this.formData

        if (Number(subsidyMethod) === 0 && Number(opt.value) === 1) return false
        if (Number(subsidyMethod) === 1 && Number(opt.value) === 0) return false

        return true
      }
      return this.defaultOption.deliveryMethodOptions.filter(excludeOptions)
    },
    subsidyMethodOptions() {
      const excludeOptions = (opt) => {
        const { deliveryMethod, subsidyMethod } = this.formData

        if (Number(deliveryMethod) === 0 && Number(opt.value) === 1)
          return false
        if (Number(deliveryMethod) === 1 && Number(opt.value) === 0)
          return false

        return true
      }
      return this.defaultOption.subsidyMethodOptions.filter(excludeOptions)
    },
  },
  methods: {
    changSubsidy(val) {
      console.log(val)
    },
    fillHistoryAddressGps(fieldName) {
      const { address, gps } = this.selectedHistoryAddress
      const payload = { geo: { gps: { coordinates: gps }, address } }
      this.handleLocation(fieldName, payload)
      this.$set(this, 'selectedHistoryAddress', null)
    },
    handleUserChange(event) {
      this.$set(this.formData, 'longTermCareUserId', event.id)
      longTermCareService.queryUserDetail(event.id).then((raw) => {
        console.log(raw)
        this.$set(
          this,
          'historyAddressData',
          _.uniqBy(
            raw.result.historyAddressData,
            (item) => `${item.address}+${item.gps}`,
          ),
        )
      })
    },
    calculateSubsidyFare() {
      if (!this.selectedUser) return this.$message.error('長照用戶資料有誤')
      const { id } = this.selectedUser
      const { subsidyMethod: subsidy_method, metreFare: metre_fare } =
        this.formData
      longTermCareService
        .getSubsidyAmount(id, { subsidy_method, metre_fare })
        .then(({ result = {}, message }) => {
          this.$message.success(message)
          const { subsidyFare, actualFare } = result
          this.$set(this.formData, 'subsidyFare', subsidyFare)
          this.$set(this.formData, 'actualFare', actualFare)
        })
        .catch(({ data: { error }, message }) => {
          const { metreFare } = this.formData
          this.$set(this.formData, 'subsidyFare', 0)
          this.$set(this.formData, 'actualFare', metreFare)
          this.$message.error(message || error.message)
        })
    },
    resetFrom() {
      this.formData = {}
      this.back()
    },
    back() {
      setTimeout(() => this.$router.push({ name: 'longTermOrderList' }), 500)
    },
    saveUser(params) {
      if (!this.selectedUser) return this.$message.error('長照用戶資料有誤')

      const { id } = this.selectedUser
      var formData = new FormData()
      ;['areaType', 'class'].forEach((key) => {
        if (is.existy(this.formData[key])) {
          formData.append(key, this.selectedUser[key])
        }
      })

      longTermCareService
        .updateUser(id, formData)
        .then((data) => {
          this.$message.success(data.message)
          return data
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
    makeupOrder() {
      let data = {}
      ;[
        'longTermCareUserId',
        'deliveryMethod',
        'estimateGetOnTime',
        'onLocation',
        'offLocation',
        'seat',
        'driverId',
        'licenseNumber',
        'subsidyMethod',
        'subsidyFare',
        'metreFare',
        'actualFare',
        'onLocationGps',
        'offLocationGps',
        'getOnTime',
        'getOffTime',
        'milage',
        'serviceNote',
        /**/
      ].forEach((key) => {
        if (is.existy(this.formData[key])) {
          data[key] = this.formData[key]
        }
      })

      if (Array.isArray(this.formData['service'])) {
        data['service'] = _.filter(this.formData['service'], (val) => val)
      }

      if (data.onLocationGps.length === 0) {
        delete data.onLocationGps
      }
      if (data.offLocationGps.length === 0) {
        delete data.offLocationGps
      }
      longTermCareService
        .makeupOrder(data)
        .then((data) => {
          this.$message.success(data.message)
          this.back()
          return data
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/longterm-care.scss';
.el-autocomplete {
  .el-input__inner {
    width: 300px;
  }
}
.page-content {
  position: relative;
  max-width: 960px;
  width: 100%;
  margin: auto;
}
.el-form-item__row,
.el-form-item__row .el-form-item__content {
  position: relative;
  width: 100%;
  display: block;
}

.el-form-item__row .el-form-item__label {
  position: absolute;
  top: 0;
}

.el-form-item__content .el-input__inner {
  width: auto;
}

.el-form-item__content .el-input,
.el-form-item__content .el-textarea {
  display: inline-block;
  width: auto;
}
.el-col {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/MakeupOrderForm.vue